import { forwardRef } from 'react'

const Button = forwardRef(function Button(
  {
    children,
    variant = 'primary',
    size = 'default',
    className = '',
    disabled = false,
    loading = false,
    type = 'button',
    ...props
  },
  ref
) {
  const baseClass = 'btn'
  const variantClass = `btn-${variant}`
  const sizeClass = size !== 'default' ? `btn-${size}` : ''

  const classes = [baseClass, variantClass, sizeClass, className]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <>
          <span className="spinner" style={{ width: 16, height: 16 }} />
          Loading...
        </>
      ) : (
        children
      )}
    </button>
  )
})

export default Button
